import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import SVGIcon from '../../ui/common/common/svgicon/svgicon.jsx'
import IntlMessage from '../../ui/common/common/intl/intl_message.jsx'

// TODO: move color declaration to a common place
const textColor = '#b8bdbd'
const textAltColor = '#333'
const borderAltColor = '#4dbce9'

// TODO: move this to shared styling helpers, so that any component can use the animation
const commonSlideInDown = ({
  count = 1,
  duration = '1s',
  delay = '0s',
  animation = 'ease',
  fill = 'both',
  visibility = 'hidden'
}) => `
  animation-name: common-slide-in-down;
  animation-iteration-count: ${count};
  animation-duration: ${duration};
  animation-delay: ${delay};
  animation-timing-function: ${animation};
  animation-fill-mode: ${fill};
  backface-visibility: ${visibility};
  animation-timing-function: cubic-bezier(.405, .175, 0, 1.025);
`

const IconWrap = styled.span`
  ${commonSlideInDown({ duration: '600ms', delay: '200ms' })}
  display: inline-block;
  float: left;
  padding-top: 4px;
  color: currentColor;
  :before {
    content: '';
    margin-left: 10px;
  }
`

const Icon = ({ name }) => (
  <IconWrap>
    <SVGIcon name={name} />
  </IconWrap>
)

Icon.propTypes = {
  name: PropTypes.string
}

const HeaderCellWrap = styled.div`
  cursor: pointer;
  float: left;
  font-size: 13px;
  font-weight: 300;
  line-height: 23px;
  margin: 0 auto;
  overflow: hidden;
  padding: 16px 20px 9px;
  position: relative;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
  display: inline-flex;
  width: ${props => props.width};
  color: ${props => (props.active ? textAltColor : textColor)};
  border-bottom: ${props => (props.active ? `3px solid ${borderAltColor}` : 0)};
  cursor: ${props => (props.onClick ? 'pointer' : 'default')};
`

const LabelWrap = styled.span`
  float: left;
`

const Label = ({ identifier }) => (
  <LabelWrap>
    <IntlMessage ident={identifier} />
  </LabelWrap>
)

Label.propTypes = {
  identifier: PropTypes.string
}

const HeaderCell = ({ active, onClick, sortAsc, labelIdentifier, showSortIcon, width }) => (
  <HeaderCellWrap width={width} active={active} onClick={onClick}>
    <Label identifier={labelIdentifier} />
    {showSortIcon && <Icon name={sortAsc ? 'arrow-up' : 'arrow-down'} />}
  </HeaderCellWrap>
)

HeaderCell.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  sortAsc: PropTypes.bool,
  labelIdentifier: PropTypes.string,
  showSortIcon: PropTypes.bool,
  width: PropTypes.string.isRequired
}

export default HeaderCell
